import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FynixLanding from "@/pages/FynixLanding";
import AdminLeads from "@/pages/AdminLeads";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FynixLanding />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
